export const REQUEST_USER = 'zola/user/REQUEST_USER';
export const RECEIVE_USER = 'zola/user/RECEIVE_USER';
export const IDENTIFY_USER = 'zola/user/IDENTIFY_USER';
export const IDENTIFY_GUEST_USER = 'zola/user/IDENTIFY_GUEST_USER';
export const REQUEST_USER_STATUS = 'zola/user/REQUEST_USER_STATUS';
export const RECEIVE_USER_STATUS = 'zola/user/RECEIVE_USER_STATUS';



// WEBPACK FOOTER //
// ./src/actions/types/UserActionTypes.ts